import { WebsiteType, WebsiteStatus } from "../types/websites";

export interface WebsiteDeleteResponse {
  ok: boolean;
  success: boolean;
}

export interface Product {
  product_id: string;
  type: string;
}

// Interfaz principal que define la estructura de un sitio web
export interface Website {
  userId: string;
  projectId: string;
  websiteId: string;
  name: string;
  productName: string;
  type: WebsiteType;
  status: WebsiteStatus;
  url: string;
  visits: number;
  conversionRate: number;
  theme: string;
  lastEdited: string;
  createdAt: string;
  sales_angle: string;
  sales_angle_description: string;
  products: Product[];
  configurations: {
    enabled: boolean;
    name_funnel: string;
  };
  idSequence: number;
  brand_name: string;
}

// Interfaz para la URL de visualización
export interface UrlDisplay {
  full: string; // URL completa para el enlace
  short: string; // Versión corta para mostrar
}

// Interfaz para el estado del almacén de sitios web
export interface WebsitesState {
  projectId: string | null;
  userId: string | null;
  websites: Website[];
  tempChanges: Record<string, Partial<Website>>;
  hasChanges: boolean;
  isLoading: boolean;

  addWebsite: (
    website: Omit<Website, "id" | "createdAt" | "lastEdited">
  ) => void;
  deleteWebsite: (userId: string, id: string) => Promise<string>;
  setTempChanges: (changes: Record<string, Partial<Website>>) => void;

  initialize: () => Promise<void>; // used to get websites from project id
  projectActive: () => Promise<string>;
}

export interface SortConfig {
  key: keyof Website | null;
  direction: "asc" | "desc";
}

export enum ProductType {
  PRINCIPAL = "PRINCIPAL",
  UP_SELL = "UP_SELL",
  BUMP_OFFER = "BUMP_OFFER",
}
